import { ThemeToggle } from './ThemeToggle';
import { MobileNavigation } from './MobileNavigation';
import UserMenu from '@/components/layout/UserMenu';

export const TopNavbar = ({ navigation, darkMode, setDarkMode, user, handleSignOut }) => {
    return (
        <nav className="fixed top-0 right-0 h-16 md:left-64 left-0 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 z-50">
            <div className="h-full px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-full">
                    <MobileNavigation navigation={navigation} />
                    <div className="flex items-center space-x-2 ml-auto">
                        <div className='hidden'>
                            <ThemeToggle darkMode={darkMode} setDarkMode={setDarkMode} />
                        </div>
                        <UserMenu
                            userEmail={user?.email}
                            handleSignOut={handleSignOut}
                        />
                    </div>
                </div>
            </div>
        </nav>
    );
};